import React, { useEffect, useMemo } from "react";
import { Row, Col, Select, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useListarHistoricoDescansoMedico, useDrawerCargarHistorico } from "../../hooks";

const { Option } = Select;

const aniosDisponibles = () => {
  const anioActual = new Date().getFullYear();
  const anios = [];
  for (let a = anioActual; a >= anioActual - 5; a--) {
    anios.push(a);
  }
  return anios;
};

const FiltroDescansoMedico = () => {
  const {
    historico,
    anioFiltro,
    filtroColaborador,
    filtroSubsidio,
    onCambiarAnio,
    onCambiarColaborador,
    onCambiarSubsidio,
    listar,
  } = useListarHistoricoDescansoMedico();
  const { mostrar } = useDrawerCargarHistorico();

  useEffect(() => {
    listar(anioFiltro);
  }, []);

  const opcionesColaborador = useMemo(() => {
    const mapa = new Map();
    (historico || []).forEach((h) => {
      if (h.colaboradorNumeroDocumentoIdentidad && !mapa.has(h.colaboradorNumeroDocumentoIdentidad)) {
        mapa.set(h.colaboradorNumeroDocumentoIdentidad, h.colaboradorNombreCompleto);
      }
    });
    return Array.from(mapa, ([dni, nombreCompleto]) => ({ dni, nombreCompleto }));
  }, [historico]);

  return (
    <Row justify="space-between" align="middle" style={{ marginBottom: "12px" }}>
      <Col>
        <Row align="middle" gutter={8}>
          <Col>
            <span>Año:</span>
          </Col>
          <Col>
            <Select value={anioFiltro} onChange={onCambiarAnio} style={{ width: 100 }}>
              {aniosDisponibles().map((a) => (
                <Option key={a} value={a}>
                  {a}
                </Option>
              ))}
            </Select>
          </Col>
          <Col>
            <span>Colaborador:</span>
          </Col>
          <Col>
            <Select
              value={filtroColaborador}
              onChange={onCambiarColaborador}
              style={{ width: 250 }}
              placeholder="Todos los colaboradores"
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {opcionesColaborador.map((c) => (
                <Option key={c.dni} value={c.dni}>
                  {c.nombreCompleto}
                </Option>
              ))}
            </Select>
          </Col>
          <Col>
            <span>Subsidio:</span>
          </Col>
          <Col>
            <Select
              value={filtroSubsidio}
              onChange={onCambiarSubsidio}
              style={{ width: 120 }}
              placeholder="Todos"
              allowClear
            >
              <Option value={true}>Sí</Option>
              <Option value={false}>No</Option>
            </Select>
          </Col>
        </Row>
      </Col>
      <Col>
        <Button type="primary" icon={<PlusOutlined />} onClick={mostrar}>
          Cargar Histórico
        </Button>
      </Col>
    </Row>
  );
};

export default FiltroDescansoMedico;
